import { css } from '@emotion/react'

export const tooltipContainer = css`
  display: initial;
`
